export const facebookURL = 'http://www.facebook.com/notonthehighstreet/';
export const twitterURL = 'http://twitter.com/notonthehighst/';
export const tiktokURL = 'https://www.tiktok.com/@notonthehighstreet';
export const pinterestURL = 'http://pinterest.com/notonthehighst/';
export const instagramURL = 'http://instagram.com/notonthehighstreet/';
